import { filterContent } from 'legacy/lut/components/widgets/public/partnerDuplicates/components/partnerDuplicatesContent/partnerDuplicatesRow/expandedRowContent/helpers/filterContent'
import { useCallback, useMemo, useState } from 'react'

import { IPartner, IPartnerDuplicate } from 'clickNgo/entities/partner/models'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'

import {
  IContentActions,
  IContentMessages,
  TPartnerDuplicatesContentAction,
  TPartnerDuplicatesContentMessage,
} from '../../../../../models'

import styles from './PartnerDuplicatesContentActions.module.scss'

interface IPartnerDuplicatesContentActionsProps extends IContentActions {
  partner: IPartner
  searchResult: IPartnerDuplicate
}

export const PartnerDuplicatesContentActions = ({
  contentActions = [],
  partner,
  searchResult,
}: IPartnerDuplicatesContentActionsProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const filterFn = useMemo(() => filterContent(partner, searchResult), [partner, searchResult])

  const mapContentActions = useCallback(
    (button: TPartnerDuplicatesContentAction) => (
      <Button
        key={button.title}
        disabled={isLoading || !button.checkVisibility({ partner, duplicate: searchResult })}
        onClick={() => {
          setIsLoading(true)
          button.onClick({ partner, duplicate: searchResult }, () => {
            setIsLoading(false)
          })
        }}
      >
        {isLoading && <Loader dimension={{ width: 24, height: 24 }} />}
        {!isLoading && <Translation text={button.title} span />}
      </Button>
    ),
    [isLoading, partner, searchResult]
  )

  return (
    <div className={styles.actionBtn}>{contentActions.filter(filterFn).map(mapContentActions)}</div>
  )
}
